import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import config from 'config';
import { normalize, denormalize } from 'normalizr';
import { loadSession, VisitorStatus } from './bentoApiModule';
import createAction from './createAction';
import { HTTPError } from './fetch';
import logger from './logger';
import { getNewDateFunction, isTimeTravelActive } from './timeModule';
import { getHeaderValuesByKeys, errorResponseHeadersToTrack } from './utils';
var debug = logger.extend('bentoApiReduxMiddleware');
export var BENTO_API = 'bentoApi';
export var BentoApiError = /*#__PURE__*/function (_Error) {
  _inherits(BentoApiError, _Error);

  var _super = _createSuper(BentoApiError);

  function BentoApiError(action) {
    var _this;

    _classCallCheck(this, BentoApiError);

    _this = _super.call(this, action.payload.toString());
    var payload = action.payload;
    _this.name = 'BentoApiError';
    _this.action = action;
    _this.originalError = payload;
    _this.statusCode = payload && payload.response ? payload.response.status : undefined;

    if (payload.response) {
      var _ref = (action === null || action === void 0 ? void 0 : action.meta) || {},
          endpoint = _ref.endpoint,
          fetchOptions = _ref.fetchOptions,
          responseBody = _ref.responseBody;

      var headerValues = getHeaderValuesByKeys(payload.response.headers, errorResponseHeadersToTrack); // Validate that this is a T1 Error via response headers

      var isTier1Request = Object.keys(headerValues).includes('x-tfg-tier1-server');

      if (isTier1Request) {
        var _responseBody$error, _responseBody$error$p, _responseBody$error2, _responseBody$error2$, _responseBody$error3;

        _this.customData = _objectSpread(_objectSpread({}, headerValues), {}, {
          'x-tier1-endpoint': endpoint,
          'x-tier1-fetch-options': JSON.stringify(fetchOptions),
          'x-tier1-message': responseBody === null || responseBody === void 0 ? void 0 : responseBody.message,
          'x-tier1-node-version': responseBody === null || responseBody === void 0 ? void 0 : (_responseBody$error = responseBody.error) === null || _responseBody$error === void 0 ? void 0 : (_responseBody$error$p = _responseBody$error.process) === null || _responseBody$error$p === void 0 ? void 0 : _responseBody$error$p.version,
          'x-tier1-stack': (responseBody === null || responseBody === void 0 ? void 0 : (_responseBody$error2 = responseBody.error) === null || _responseBody$error2 === void 0 ? void 0 : (_responseBody$error2$ = _responseBody$error2.stack) === null || _responseBody$error2$ === void 0 ? void 0 : _responseBody$error2$.join('\n')) || JSON.stringify(responseBody === null || responseBody === void 0 ? void 0 : (_responseBody$error3 = responseBody.error) === null || _responseBody$error3 === void 0 ? void 0 : _responseBody$error3.stack)
        });
      }
    }

    return _this;
  }

  return _createClass(BentoApiError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export function toActionCreator(typeDescriptor) {
  switch (_typeof(typeDescriptor)) {
    case 'function':
      return typeDescriptor;

    case 'object':
      return function (payload, meta) {
        return _objectSpread({
          payload: payload,
          meta: meta
        }, typeDescriptor);
      };

    default:
      return createAction(typeDescriptor);
  }
}

function handleBentoAction(_x, _x2, _x3, _x4) {
  return _handleBentoAction.apply(this, arguments);
}

function _handleBentoAction() {
  _handleBentoAction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(store, next, action, context) {
    var client, _action$BENTO_API, endpoint, _action$BENTO_API$ses, sessionRequired, _action$BENTO_API$log, loginRequired, requestKey, schema, actions, fetchOptions, _actions$map, _actions$map2, createRequest, createSuccess, createFailure, sessionResult, _store$getState, session, executeRequest, promise, onSuccess, onError;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            client = context[BENTO_API];
            _action$BENTO_API = action[BENTO_API], endpoint = _action$BENTO_API.endpoint, _action$BENTO_API$ses = _action$BENTO_API.sessionRequired, sessionRequired = _action$BENTO_API$ses === void 0 ? true : _action$BENTO_API$ses, _action$BENTO_API$log = _action$BENTO_API.loginRequired, loginRequired = _action$BENTO_API$log === void 0 ? endpoint.startsWith('accounts/me/') : _action$BENTO_API$log, requestKey = _action$BENTO_API.requestKey, schema = _action$BENTO_API.schema, actions = _action$BENTO_API.actions, fetchOptions = _objectWithoutProperties(_action$BENTO_API, ["endpoint", "sessionRequired", "loginRequired", "requestKey", "schema", "actions"]);

            if (endpoint) {
              _context2.next = 4;
              break;
            }

            throw new Error("Missing 'endpoint' option in 'bentoApi'.");

          case 4:
            if (actions) {
              _context2.next = 6;
              break;
            }

            throw new Error("Missing 'actions' option in 'bentoApi'.");

          case 6:
            _actions$map = actions.map(toActionCreator), _actions$map2 = _slicedToArray(_actions$map, 3), createRequest = _actions$map2[0], createSuccess = _actions$map2[1], createFailure = _actions$map2[2];

            if (!sessionRequired) {
              _context2.next = 13;
              break;
            }

            _context2.next = 10;
            return store.dispatch(loadSession());

          case 10:
            sessionResult = _context2.sent;

            if (!(sessionResult && sessionResult.error)) {
              _context2.next = 13;
              break;
            }

            throw sessionResult.payload;

          case 13:
            if (!loginRequired) {
              _context2.next = 18;
              break;
            }

            _store$getState = store.getState(), session = _store$getState.session;

            if (!(session.visitorStatus !== VisitorStatus.LOGGED_IN)) {
              _context2.next = 18;
              break;
            }

            debug('Skipping “%s” request due to visitor status.', endpoint);
            return _context2.abrupt("return");

          case 18:
            executeRequest = /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var state, newDate, fetchedDate, meta, requestAction, _state$BENTO_API, contentPreview, requestFailureRate, requestFailureType, session, isAdmin, resultAction, response, _payload, _normalize, result, entities, responseBody, clonedResponse, text, finalAction, _finalAction$payload, _finalAction$payload$, isUnauthorized, reloadUnauthorized, url, isForcedReloadPage;

                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        state = store.getState();
                        newDate = getNewDateFunction(state);
                        fetchedDate = newDate();
                        meta = {
                          endpoint: endpoint,
                          sessionRequired: sessionRequired,
                          requestKey: requestKey,
                          schema: schema,
                          fetchOptions: fetchOptions,
                          fetchedDate: fetchedDate.toISOString(),
                          isServer: context.isServer
                        };
                        requestAction = createRequest(null, meta);
                        _context.next = 7;
                        return store.dispatch(requestAction);

                      case 7:
                        _state$BENTO_API = state[BENTO_API], contentPreview = _state$BENTO_API.contentPreview, requestFailureRate = _state$BENTO_API.requestFailureRate, requestFailureType = _state$BENTO_API.requestFailureType;

                        if (requestFailureRate) {
                          fetchOptions.failureRate = requestFailureRate;
                        }

                        if (requestFailureType) {
                          fetchOptions.failureType = requestFailureType;
                        } // Time Travel


                        if (isTimeTravelActive(state)) {
                          fetchOptions.headers = _objectSpread({
                            'x-tfg-effective-date': fetchedDate.toISOString()
                          }, fetchOptions.headers);
                        } // tos_token security management to allow admin sessions to work across builder.io and other tabs
                        // Tells API to loosen SameSite security setting for tos_token session cookie when responding with updated/new session cookie.


                        session = state.session;
                        isAdmin = Boolean(session.isAdmin);

                        if (isAdmin || contentPreview) {
                          fetchOptions.headers = _objectSpread({
                            'x-tfg-content-preview': 'true'
                          }, fetchOptions.headers);
                        }

                        _context.prev = 14;
                        _context.next = 17;
                        return client(endpoint, fetchOptions);

                      case 17:
                        response = _context.sent;
                        _payload = null;

                        if (!(response.status !== 204)) {
                          _context.next = 24;
                          break;
                        }

                        _context.next = 22;
                        return response.json();

                      case 22:
                        _payload = _context.sent;

                        if (schema) {
                          _normalize = normalize(_payload, schema), result = _normalize.result, entities = _normalize.entities;
                          meta = _objectSpread(_objectSpread({}, meta), {}, {
                            result: result,
                            entities: entities
                          });
                          _payload = denormalize(result, schema, entities);
                        }

                      case 24:
                        resultAction = createSuccess(_payload, meta);
                        _context.next = 50;
                        break;

                      case 27:
                        _context.prev = 27;
                        _context.t0 = _context["catch"](14);

                        if (_context.t0 instanceof Error) {
                          _context.next = 31;
                          break;
                        }

                        throw _context.t0;

                      case 31:
                        if (!(typeof window !== 'undefined' && _context.t0.name === 'TypeError' && _context.t0.message === 'cancelled')) {
                          _context.next = 33;
                          break;
                        }

                        return _context.abrupt("return", new Promise(function (resolve, reject) {}));

                      case 33:
                        if (!(_context.t0 instanceof HTTPError)) {
                          _context.next = 40;
                          break;
                        }

                        if (!_context.t0.response) {
                          _context.next = 40;
                          break;
                        }

                        // Preserve original response body for deeper error logging
                        clonedResponse = _context.t0.response.clone();
                        _context.next = 38;
                        return clonedResponse.text();

                      case 38:
                        text = _context.sent;

                        try {
                          responseBody = text ? JSON.parse(text) : undefined;
                        } catch (e) {
                          responseBody = undefined;
                        }

                      case 40:
                        resultAction = createFailure(_context.t0, responseBody ? _objectSpread(_objectSpread({}, meta), {}, {
                          responseBody: responseBody
                        }) : meta); // Just like we return the result of `store.dispatch(resultAction)` below
                        // instead of `resultAction` directly, we should be consistent and get the
                        // final dispatched result of the failure action, too. This allows other
                        // middleware to make further decisions on the action.

                        _context.next = 43;
                        return store.dispatch(resultAction);

                      case 43:
                        finalAction = _context.sent;

                        if (!finalAction.error) {
                          _context.next = 49;
                          break;
                        }

                        if (!context.isServer) {
                          isUnauthorized = ((_finalAction$payload = finalAction.payload) === null || _finalAction$payload === void 0 ? void 0 : (_finalAction$payload$ = _finalAction$payload.response) === null || _finalAction$payload$ === void 0 ? void 0 : _finalAction$payload$.status) === 401;
                          reloadUnauthorized = config.get('public.bentoApi.reloadUnauthorized');

                          if (isUnauthorized && reloadUnauthorized) {
                            url = new URL(window.location.href); // Detect if we've already reloaded; don't want to cause a loop.

                            isForcedReloadPage = url.searchParams.get('reload') === 'true';

                            if (!isForcedReloadPage) {
                              url.searchParams.set('reload', 'true');
                              window.location.href = url.toString();
                            }
                          }
                        }

                        throw new BentoApiError(finalAction);

                      case 49:
                        return _context.abrupt("return", finalAction);

                      case 50:
                        return _context.abrupt("return", store.dispatch(resultAction));

                      case 51:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[14, 27]]);
              }));

              return function executeRequest() {
                return _ref3.apply(this, arguments);
              };
            }();

            if (!requestKey) {
              _context2.next = 24;
              break;
            }

            promise = context.inflight.get(requestKey);

            if (!promise) {
              _context2.next = 24;
              break;
            }

            debug('Skipping “%s” request due to matching inflight key “%s”.', endpoint, requestKey);
            return _context2.abrupt("return", promise);

          case 24:
            promise = executeRequest();

            if (requestKey) {
              onSuccess = function onSuccess(result) {
                context.inflight["delete"](requestKey);
                return result;
              };

              onError = function onError(err) {
                context.inflight["delete"](requestKey);
                throw err;
              };

              promise = promise.then(onSuccess, onError);
              context.inflight.set(requestKey, promise);
            }

            return _context2.abrupt("return", promise);

          case 27:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _handleBentoAction.apply(this, arguments);
}

export function createBentoAction(clientCall) {
  return _defineProperty({}, BENTO_API, clientCall);
}
export default function createBentoApiReduxMiddleware(context) {
  return function (store) {
    return function (next) {
      return function (action) {
        if (!action.type && action[BENTO_API]) {
          return handleBentoAction(store, next, action, context);
        }

        return next(action);
      };
    };
  };
}